/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { StoricoCampoDTO } from '../model/models';
import { StoricoSnapshotDTO } from '../model/models';
import { StoricoValoreADataDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface GetPraticaStoricoCampoRequestParams {
    idTipoPratica: string;
    idPratica: string;
    target: 'PRATICA_ROOT' | 'ANAGRAFICA' | 'COMPONENTE' | 'EAV';
    fieldName?: string;
    componenteId?: string;
    eavTarget?: 'ANAGRAFICA_RICHIEDENTE' | 'NUCLEO_FAMILIARE_COMPONENTE' | 'PRATICA_ROOT';
    attributoId?: string;
}

export interface GetPraticaStoricoSnapshotRequestParams {
    idTipoPratica: string;
    idPratica: string;
    at?: string;
}

export interface GetPraticaStoricoValoreADataRequestParams {
    idTipoPratica: string;
    idPratica: string;
    target: 'PRATICA_ROOT' | 'ANAGRAFICA' | 'COMPONENTE' | 'EAV';
    fieldName?: string;
    componenteId?: string;
    eavTarget?: 'ANAGRAFICA_RICHIEDENTE' | 'NUCLEO_FAMILIARE_COMPONENTE' | 'PRATICA_ROOT';
    attributoId?: string;
    at?: string;
}


export interface GestioneStoricoPraticaServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Cronologia forense di un singolo campo: tutte le righe (incluse le tombstone) ordinate per data crescente. Campo identificato dal selettore (target + fieldName per i nativi; target&#x3D;EAV + eavTarget + attributoId [+ componenteId per il nucleo] per gli attributi dinamici). Nessun parametro &#x60;at&#x60;. Campo mai versionato → 200 con cronologia vuota.
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche/{idPratica}/storico/campo
* @param requestParameters
     */
    getPraticaStoricoCampo(requestParameters: GetPraticaStoricoCampoRequestParams, extraHttpRequestParams?: any): Observable<StoricoCampoDTO>;

    /**
     * Fotografia dell\&#39;intera pratica al tempo &#x60;at&#x60; (ISO-8601 Instant obbligatorio): campi non-tombstone validi a quell\&#39;istante, in 4 sezioni (root/anagrafica/componenti/eav) con valore type-preserving ed etichetta umana. Pratica legacy senza storico → 200 con sezioni vuote.
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche/{idPratica}/storico/snapshot
* @param requestParameters
     */
    getPraticaStoricoSnapshot(requestParameters: GetPraticaStoricoSnapshotRequestParams, extraHttpRequestParams?: any): Observable<StoricoSnapshotDTO>;

    /**
     * Valore di un singolo campo al tempo &#x60;at&#x60; (ISO-8601 Instant obbligatorio). Selettore come per la cronologia. Se nessuna riga e\&#39; valida a &#x60;at&#x60; (campo assente/tombstoned/&#x60;at&#x60; pre-prima-versione) → 200 con presente&#x3D;false.
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche/{idPratica}/storico/campo/valore-a-data
* @param requestParameters
     */
    getPraticaStoricoValoreAData(requestParameters: GetPraticaStoricoValoreADataRequestParams, extraHttpRequestParams?: any): Observable<StoricoValoreADataDTO>;

}
